export const EXPLORER_ADDR = "https://etherscan.io/address/"
export const EXPLORER_TX = "https://etherscan.io/tx/"